export const countWords = (segments) => segments.reduce((total, segment) => {
  const text = segment.text || segment.content || segment.transcript || '';
  return total + text.trim().split(/\s+/).filter(Boolean).length;
}, 0);
